export default __webpack_public_path__ + "static/media/correct-sound.d99bf5cd.mp3";